import { BaseModel } from "@blue-chip/core";

export default class Tag extends BaseModel {}
